/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * WebhookDtoBase
 * auto generated base class for the model WebhookDtoModel.
 */
export const WebhookDtoModelBase = ModelBase
  .named('WebhookDto')
  .props({
    __typename: types.optional(types.literal("WebhookDto"), "WebhookDto"),
    id: types.identifier,
    /** Destination URL events are delivered to */
    url: types.union(types.undefined, types.string),
    /** Optional human-readable label */
    label: types.union(types.undefined, types.null, types.string),
    /** Whether the webhook is delivering events */
    active: types.union(types.undefined, types.boolean),
    /** Event topics this webhook is subscribed to */
    topics: types.union(types.undefined, types.array(types.string)),
    /** ISO timestamp when the webhook was created */
    createdAt: types.union(types.undefined, types.string),
    /** UUID of the user who created the webhook */
    createdByUserUuid: types.union(types.undefined, types.null, types.string),
    /** Display name of the user who created the webhook, resolved at read time */
    createdByName: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WebhookDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get url() { return this.__attr(`url`) }
  get label() { return this.__attr(`label`) }
  get active() { return this.__attr(`active`) }
  get topics() { return this.__attr(`topics`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get createdByUserUuid() { return this.__attr(`createdByUserUuid`) }
  get createdByName() { return this.__attr(`createdByName`) }
}
export function selectFromWebhookDto() {
  return new WebhookDtoModelSelector()
}

export const webhookDtoModelPrimitives = selectFromWebhookDto().url.label.active.topics.createdAt.createdByUserUuid.createdByName
